import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FilterLinesForIntegrationFilter } from 'flow-doctor-lib/utils/filterRenderUtils';
import WalmartAbstractFilterRenderer from 'flow-doctor-lib/components/filters/WalmartAbstractFilterRenderer';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import useLegacyIntegrationEvent from 'flow-doctor-lib/hooks/useLegacyIntegrationEvent';
import { jsx as _jsx } from "react/jsx-runtime";
const WalmartIntegrationFilterRenderer = ({
  filter
}) => {
  const {
    data,
    loading,
    error
  } = useLegacyIntegrationEvent({
    portalId: PortalIdParser.get(),
    eventId: filter.eventTypeId
  });
  if (!error && (loading || !data)) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200
    });
  }
  return /*#__PURE__*/_jsx(WalmartAbstractFilterRenderer, {
    heading: data ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.filters.integration.label",
      options: {
        appName: data.appName,
        eventName: data.name
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.filters.integration.labelNoData",
      options: {
        eventTypeId: filter.eventTypeId.toString()
      }
    }),
    filterLine: /*#__PURE__*/_jsx(FilterLinesForIntegrationFilter, {
      filter: filter
    })
  });
};
export default WalmartIntegrationFilterRenderer;